import React from 'react'
import PropTypes from 'prop-types'

const IDField = ({ source, record = {} }) => {
  const fullId = record[source]

  return (
    <span title={fullId}>{fullId.slice(-6)}</span>
  )
}

IDField.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired
}

export default IDField



// WEBPACK FOOTER //
// ./src/components/idField.js